import { Children, isValidElement, memo, ReactElement, ReactNode } from 'react'
import cn from 'classnames'
import { useIsMobile } from 'hooks/media'

import s from './TabList.module.less'
import cs from 'src/common.module.less'

interface IProps {
  children: ReactNode
  className?: string
}

export const TabList = memo(function TabList({ className, children }: IProps) {
  const isMobile = useIsMobile()
  const items = Children.toArray(children).filter((child) => isValidElement(child)) as ReactElement[]

  return items.length > 1 ? (
    <div
      className={cn(className, cs.flex, s.root, {
        [s.root_mobile]: isMobile,
        [cs.marginL16]: isMobile
      })}
    >
      {children}
    </div>
  ) : null
})
